<markant-dialog
  class="dialog small"
  [headTitle]="
    'organization.users.remove.alternativeOwner.availableAdmins.noAdminAvailable.header'
      | transloco
  "
  [open]="isNoAdminAvailableOpen"
  (close)="closeDialog()"
>
  <div class="info">
    {{
      'organization.users.remove.alternativeOwner.availableAdmins.noAdminAvailable.' +
        (mode === 'delete' ? 'deleteInfo' : 'info') | transloco
    }}
  </div>

  <div slot="markant-dialog-footer">
    <markant-button
      colorScheme="primary"
      variant="clear"
      (click)="closeDialog()"
    >
      {{ 'common.cancel' | transloco }}
    </markant-button>
  </div>
</markant-dialog>

<markant-dialog
  *ngIf="isWarningDialogOpen"
  class="dialog small"
  [headTitle]="
    'organization.users.remove.alternativeOwner.warning.header' | transloco
  "
  [open]="isWarningDialogOpen"
  (close)="closeDialog()"
>
  <div class="info">
    {{ 'organization.users.remove.alternativeOwner.warning.text' | transloco }}
  </div>

  <markant-list class="content" *ngFor="let owner of owners; index as i">
    <markant-list-item
      [text]="
        'organization.users.remove.alternativeOwner.confirmation.user'
          | transloco: { firstname: owner.firstname, lastname: owner.lastname }
      "
    >
    </markant-list-item>
    <markant-list-item
      *ngFor="let cartridge of getCartridgeVariants(owner.userId)"
      [text]="
        'organization.users.remove.alternativeOwner.confirmation.cartridge'
          | transloco: { cartridge: cartridge }
      "
    >
    </markant-list-item>
    <markant-list-divider
      *ngIf="owners.length > 0 && i !== owners.length - 1"
    ></markant-list-divider>
  </markant-list>

  <div class="dialog-footer-actions" slot="markant-dialog-footer">
    <markant-button
      colorScheme="primary"
      variant="clear"
      (click)="closeDialog()"
    >
      {{ 'common.cancel' | transloco }}
    </markant-button>

    <markant-button colorScheme="primary" (click)="continueToAvailableAdmins()">
      {{ 'common.next' | transloco }}
    </markant-button>
  </div>
</markant-dialog>

<markant-dialog
  *ngIf="isAssignNewAdminDialogOpen"
  class="dialog"
  [headTitle]="
    'organization.users.remove.alternativeOwner.availableAdmins.header'
      | transloco
  "
  [open]="isAssignNewAdminDialogOpen"
  (close)="closeDialog()"
>
  <div class="info">
    {{
      'organization.users.remove.alternativeOwner.availableAdmins.information'
        | transloco
    }}<br /><br />
    <span>
      {{
        'organization.users.remove.alternativeOwner.availableAdmins.notice'
          | transloco
      }}
    </span>
    {{
      'organization.users.remove.alternativeOwner.availableAdmins.noticeText'
        | transloco
    }}
  </div>

  <form [formGroup]="form" class="content content-form">
    <ng-container *ngFor="let cartridge of cartridges">
      <h6 class="variant-name">{{ cartridge.name }}</h6>
      <div class="content-form-assign-owner">
        <markant-input
          data-cy="input-current-owner"
          [outlined]="true"
          [label]="
            'organization.users.remove.alternativeOwner.availableAdmins.currentOwner'
              | transloco
          "
          [value]="cartridge.currentOwner"
          [readonly]="true"
        >
        </markant-input>
        <markant-select
          *ngIf="form.get(cartridge.id) as cartridgeControl"
          id="cartridge"
          [formControlName]="cartridge.id"
          [outlined]="true"
          [placeholder]="'common.chooseText' | transloco"
          [readonly]="alternativeOwners.length! === 0"
          [label]="
            'organization.users.remove.alternativeOwner.availableAdmins.newOwner'
              | transloco
          "
          [error]="
            cartridgeControl.errors
              | formControlKeyError
                : 'organization.users.remove.alternativeOwner.availableAdmins.error'
                : showErrors ||
                    cartridgeControl.touched ||
                    cartridgeControl.dirty
                : true
              | transloco
          "
          [options]="alternativeOwnerOptions"
        >
        </markant-select>
      </div>
    </ng-container>
  </form>
  <div class="dialog-footer-actions" slot="markant-dialog-footer">
    <markant-button
      colorScheme="primary"
      variant="clear"
      (click)="closeDialog()"
    >
      {{ 'common.cancel' | transloco }}
    </markant-button>
    <markant-button (click)="assignNewOwners()" colorScheme="primary">
      {{ 'common.save' | transloco }}
    </markant-button>
  </div>
</markant-dialog>
